import type { RouteObject } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { FULL_WIDTH_PAGE } from '@/shared/layouts/pageLayout';
import { SecurityGroupList } from '../pages/SecurityGroupList';
import { SecurityGroupCreate } from '../pages/SecurityGroupCreate';
import { SecurityGroupDetail } from '../pages/SecurityGroupDetail';
import { SecurityGroupEdit } from '../pages/SecurityGroupEdit';
import { SECURITY_ADMIN_ROLES } from './securityAdminRoles';

export const securityAdminRoutes: RouteObject[] = [
  {
    path: 'admin/security-groups',
    children: [
      {
        element: (
          <PermissionRoute
            requiredPermissions={[{ resource: 'security_group', action: 'browse' }]}
            requiredRoles={SECURITY_ADMIN_ROLES}
          />
        ),
        children: [
          { index: true, element: <SecurityGroupList /> },
        ],
      },
      {
        element: (
          <PermissionRoute
            requiredPermissions={[{ resource: 'security_group', action: 'add' }]}
            requiredRoles={SECURITY_ADMIN_ROLES}
          />
        ),
        children: [
          { path: 'new', element: <SecurityGroupCreate /> },
        ],
      },
      {
        // The detail route enforces the same `security_group.read` the backend enforces on
        // `GET /security/groups/{id}`, so users never land on a page that immediately 403s.
        element: (
          <PermissionRoute
            requiredPermissions={[{ resource: 'security_group', action: 'read' }]}
            requiredRoles={SECURITY_ADMIN_ROLES}
          />
        ),
        children: [
          { path: ':id', element: <SecurityGroupDetail />, handle: FULL_WIDTH_PAGE },
        ],
      },
      {
        element: (
          <PermissionRoute
            requiredPermissions={[{ resource: 'security_group', action: 'edit' }]}
            requiredRoles={SECURITY_ADMIN_ROLES}
          />
        ),
        children: [
          { path: ':id/edit', element: <SecurityGroupEdit /> },
        ],
      },
    ],
  },
];
